import React from "react";
import {
    DataGrid,
    GridActionsCellItem,
    GridColDef,
    GridEventListener,
    GridRowEditStopReasons, GridRowId, GridRowModel, GridRowModes,
    GridRowModesModel
} from "@mui/x-data-grid";
import {Link} from "react-router-dom";
import {
    Cancel,
    CancelRounded,
    CheckBoxRounded, Construction, Delete,
    DirectionsCar, Edit,
    Event,
    HelpOutlined,
    LocalDining, People, Save
} from "@mui/icons-material";
import {QuickFilterToolBar} from "../CheckIn";
import {Payment} from "../Payments";


const checkerBoxer = (params: any) => {
    if (params.value == null) {
        return <HelpOutlined/>
    }
    if (params.value) {
        return <CancelRounded htmlColor={"red"}/>
    } else {
        return <HelpOutlined/>
    }

}

export default function OustandingDataGrid(params: any) {
    const [rows, setRows] = React.useState(params.outstandingActions);
    const [rowModesModel, setRowModesModel] = React.useState<GridRowModesModel>({});
    const handleRowEditStop: GridEventListener<'rowEditStop'> = (eParams, event) => {
        if (eParams.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id: GridRowId) => () => {
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.Edit}});
    };

    const handleSaveClick = (id: GridRowId) => () => {
        setRowModesModel({...rowModesModel, [id]: {mode: GridRowModes.View}});

    };

    const handleCancelClick = (id: GridRowId) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: {mode: GridRowModes.View, ignoreModifications: true},
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow!.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };

    const processRowUpdate = (newRow: GridRowModel) => {
        const updatedRow = {...newRow};
        setRows(rows.map((row) => (row.id === newRow.id ? updatedRow : row)));

        params.onEdit(updatedRow)
        return updatedRow;
    };

    const handleRowModesModelChange = (newRowModesModel: GridRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };


    const columns: GridColDef[] = [
        {
            field: 'characterName', headerName: 'Character'
        },
        {
            field: 'playerName', headerName: 'Player',
        },
        {
            field: 'crafting', headerName: 'Crafting', align: "center", headerAlign: "center",
            renderCell: checkerBoxer,
            renderHeader: () => (<Construction/>),
            width: 70,
            editable: true,
            type: 'boolean',
            hideSortIcons: true
        }, {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            width: 100,
            cellClassName: 'actions',
            getActions: ({id}) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<Save/>}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                        />,
                        <GridActionsCellItem
                            icon={<Cancel/>}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<Edit/>}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />
                ];
            }
        }
    ]

    return (
        <React.Fragment>
            <h2>Outstanding Logistics Items</h2>
            <DataGrid slots={{toolbar: QuickFilterToolBar}}
                      editMode="row"
                      rowModesModel={rowModesModel}
                      onRowModesModelChange={handleRowModesModelChange}
                      onRowEditStop={handleRowEditStop}
                      processRowUpdate={processRowUpdate}
                      autoHeight={true}
                      disableColumnMenu={true}
                      rows={rows}
                      columns={columns}
                      getRowId={(row) => row.id}
                      disableRowSelectionOnClick
                      density={"compact"}

            />
        </React.Fragment>
    )
}